export type LanguageObject = {
	key: 'en' | 'zh' | 'es' | 'pt' | 'ms' | 'ar' | 'ko' | 'ms' | 'zh-tw' | 'pt' | 'ro' | 'fr' | 'hu' | 'cy' | 'pl' | 'it' | 'fr-ca';
	label: string;
};

export const languages: LanguageObject[] = [
	{
		key: 'en',
		label: 'English'
	},
	{
		key: 'zh',
		label: '中国'
	},
	{
		key: 'es',
		label: 'Español'
	},
	{
		key: 'pt',
		label: 'Português'
	},
	{
		key: 'ar',
		label: 'اَلْعَرَبِيَّةُ'
	},
	{
		key: 'ko',
		label: '한국어'
	},
	{
		key: 'ms',
		label: 'بهاس ملايو'
	},
	{
		key: 'zh-tw', // taiwanese doesn't have an ISO 639 language code
		label: '台語' // using the label for Taiwanese Hokkien, not sure if that's accurate
	},
	{
		key: 'ro',
		label: 'Românã'
	},
	{
		key: 'fr',
		label: 'Français'
	},
	{
		key: 'hu',
		label: 'Magyar nyelv'
	},
	{
		key: 'cy',
		label: 'Cymraeg'
	},
	{
		key: 'pl',
		label: 'Polski'
	},
	{
		key: 'it',
		label: 'Italiano'
	},
	{
		key: 'fr-ca', // French Canadian doesn't have an ISO 639 language code
		label: 'Français (Canada)' // using this label, but we should confirm
	}
];
